"use client";

import FooterFive from "@/layouts/footers/FooterFive";
import { useEffect, useState } from "react";
import axiosInstance from "@/service/axiosInstance";
import {
  getSortedSectionsWRTType,
  getSortedSectionsWRTpage,
} from "@/utils/utils";
import Loader from "@/components/Loader/Loader";
import { useSearchParams } from "next/navigation";
import { useDispatch } from "react-redux";
import { addFilter } from "@/redux/features/filterSlice";
import ScheduleListing from "./ScheduleEventList";

const ListingOne = () => {
  const dispatch = useDispatch();
  const searchParams = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [footerData, setFooterData] = useState([[]]);
  const [socialMedia, setSocialMedia] = useState([]);

  const getData = async () => {
    try {
      // const token = localStorage.getItem("token");
      setLoading(true);

      const resp: any = await axiosInstance.get("/homePage", {});
      // if (token) {
      //     if (
      //         resp?.isAuthorized?.status == 401 ||
      //         resp?.isAuthorized?.message == "Token has expired"
      //     ) {
      //         console.log("Token has expired!");
      //         toast.error("Session expired please login again", {
      //             position: toast.POSITION.TOP_RIGHT,
      //             autoClose: 3000,
      //         });
      //         localStorage.removeItem("token");
      //         dispatch(logout());
      //     }
      // }
      const footerData1 = getSortedSectionsWRTType(
        resp?.data?.data,
        "Footer",
        "Link 1",
      );

      const footerData2 = getSortedSectionsWRTType(
        resp?.data?.data,
        "Footer",
        "Link 2",
      );

      const footerData3 = getSortedSectionsWRTType(
        resp?.data?.data,
        "Footer",
        "Link 3",
      );
      const socialMediaData = getSortedSectionsWRTpage(
        resp?.data?.data,
        "Social Media",
        "Home Page",
      );
      setSocialMedia(socialMediaData);

      setFooterData([footerData1, footerData2, footerData3]);
      setLoading(false);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getData();

    // return () => {
    //   dispatch(addFilter(emptyFilter));
    // };
  }, []);
  return (
    <>
      <html>
        <head>
          <title>Event Schedule - Vibgyor Viva Event</title> {/* Page title */}
          <meta
            name="description"
            content="View the complete schedule of exciting events and activities at the Vibgyor Viva Event. Find detailed timings, event types, and more!"
          />
          <meta
            name="keywords"
            content="event schedule, Vibgyor Viva Event, event timings, activities"
          />
        </head>
      </html>

      {loading && <Loader />}

      {/* <HeaderOne style={true} /> */}
      <ScheduleListing />
      {/* <FancyBanner /> */}
      <FooterFive data={footerData} socialMedia={socialMedia} />
    </>
  );
};

export default ListingOne;
